import {
  FeatureToggleState,
  FeatureToggleStateAction,
  Reducer,
  ReducerActions,
  featureToggleStateActions,
} from '@/context/types';

const makeFeatureToggleInitialState = (): FeatureToggleState => ({
  data: [],
  isLoading: true,
  isLoaded: false,
});

const reducerActions: ReducerActions<FeatureToggleState, FeatureToggleStateAction> = (state, payload) => ({
  feature_toggle_load_start: () => ({ ...state, isLoading: true, isLoaded: false, data: [] }),
  feature_toggle_load_end: () => ({ ...state, isLoading: false, isLoaded: true, data: [...payload] }),
});

export const featureToggleReducer: Reducer<FeatureToggleState, FeatureToggleStateAction> = (state, options) => {
  const { action, payload } = options;
  return featureToggleStateActions.includes(action) ? reducerActions(state, payload)[action]() : { ...state };
};

featureToggleReducer.key = 'featureToggle';
featureToggleReducer.initialState = makeFeatureToggleInitialState();
